import styled from '@emotion/styled';
import useIsActive from '@shared/hooks/useActiveNavLink';
import { IMenuItem } from '@shared/models/components/IMenuProps';
import { NavLink } from 'react-router';
import Icons from '../images/Icons';
import { MenuActiveBar, MenuTruncate, MixinMenuBaseLink, MixinMenuFlexContainer } from './CommonMenuStyles';

interface IMenuItemProps {
    item: IMenuItem;
}

export default function MenuItem({ item }: IMenuItemProps) {
    const { exactMatch } = useIsActive(item.href);

    return (
        <>
            <MenuActiveBar isActive={exactMatch} isSubActive={!!item.activeSub} />

            {item.href ? (
                <MenuItemLink id={item.id} role="menuitem" to={item.href} target={item.target} viewTransition>
                    <MenuLabel>
                        <Icons name={item.icon} size={24} />
                        <MenuTruncate>{item.label}</MenuTruncate>
                    </MenuLabel>
                </MenuItemLink>
            ) : (
                <MenuLabel id={item.id} role="menuitem">
                    <Icons name={item.icon} size={24} />
                    <MenuTruncate>{item.label}</MenuTruncate>
                </MenuLabel>
            )}
        </>
    );
}

const MenuLabel = styled.span`
    ${MixinMenuFlexContainer}
    gap: 0.5rem;
    justify-items: center;
`;

const MenuItemLink = styled(NavLink)`
    ${MixinMenuBaseLink}
    padding:0 0.5rem;
    flex: 1;
    color: inherit;
    justify-self: center;
    &.active {
        color: ${(props) => props.theme.color.accent};
    }
`;
